import React from "react";
import { toast } from "sonner";

function linkToPageWithQuery(name, value, target) {
  let idx = window.location.href.lastIndexOf("/") + 1;

  const href =
    window.location.href.substring(0, idx) + `${target}?${name}=${value}`;

  window.open(href, "_blank");
}

function copyToClipboard(text, successMessage) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(successMessage || "복사되었습니다");
    })
    .catch(() => {
      toast.error("복사에 실패했습니다");
    });
}

const contextMenu = ({ id, isWithdrawal, accountNo }, { onAdminBalance } = {}) => {
  const menu = [
    {
      key: "orderSignedHistory",
      label: "주문내역",
      onClick: () => linkToPageWithQuery("id", id, "orderSignedHistory"),
    },
    {
      key: "memberOrderHistory",
      label: "액션로그",
      onClick: () => linkToPageWithQuery("id", id, "memberOrderHistory"),
    },
    {
      key: "memberDailyProfitNLoss",
      label: "회원일별손익",
      onClick: () => linkToPageWithQuery("id", id, "memberDailyProfitNLoss"),
    },
    {
      key: "depositNWithdrawalInquiry",
      label: "입출금내역",
      onClick: () => linkToPageWithQuery("id", id, "depositNWithdrawalInquiry"),
    },
    {
      key: "copyId",
      label: "아이디 복사",
      onClick: () => {
        copyToClipboard(id, `아이디 ${id}가 복사되었습니다`);
      },
    },
  ];

  // 출금신청인 경우 출금계좌 복사 기능 추가
  if (isWithdrawal && accountNo) {
    menu.push({
      key: "copyWithdrawalAccount",
      label: "출금계좌 복사",
      onClick: () => {
        copyToClipboard(accountNo, `출금계좌 ${accountNo}가 복사되었습니다`);
      },
    });
  }

  // 관리자 입출금 (콜백이 제공된 경우에만 노출) — 항상 메뉴 최하단
  if (typeof onAdminBalance === "function") {
    menu.push({
      key: "adminBalance",
      label: "관리자 입출금",
      onClick: () => onAdminBalance(),
    });
  }

  return menu;
};

const ContextMenu = ({ open, setOpen, contextUser, position, onAdminBalance }) => {
  if (!open) return null;
  const items = contextMenu(contextUser, { onAdminBalance });

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
      <div
        className="fixed z-50 min-w-[160px] rounded-md border bg-popover p-1 shadow-md"
        style={{
          top:
            position.y < window.innerHeight - 175
              ? position.y
              : position.y - 170,
          left: position.x,
        }}
      >
        {items.map((item) => (
          <div
            key={item.key}
            className="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"
            onClick={() => {
              item.onClick();
              setOpen(false);
            }}
          >
            {item.label}
          </div>
        ))}
      </div>
    </>
  );
};

export default ContextMenu;
